import { useSelector } from "react-redux";
const useRouteTabBar = (action) => {
  const tabBar = useSelector(state => state.tabBar);
  const leftSection = tabBar.left || null;
  const rightSection = tabBar.right || null;

  return { leftSection, rightSection };
};

export default useRouteTabBar;
